import sidebarService from '../services/sidebar';

export default {
  computed: {
    $open () {
      return !sidebarService.closed;
    },
  },
};
